// extracted by mini-css-extract-plugin
export default {"chartArea":"PreliminaryResults_chartArea__0nv4I"};